import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "form-header" }
const _hoisted_2 = { class: "header-block" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Edit Content Schedule", -1)
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "cal-section" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", null, "Oops!", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "An error occurred while saving the schedule edits."),
  /*#__PURE__*/_createTextVNode(" The Tandem team has been notified and will get back to you as soon as possible. Thanks for your patience and understanding. ")
], -1)

import { ref, onMounted, computed, watch } from "vue";
import { Settings } from "luxon";
import PlannerCalendar from "@/components/PlannerCalendar.vue";
import PlannerFinalizeModal from "@/components/PlannerFinalizeModal.vue";
import TandemModal from "@/components/TandemModal.vue";
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import useSnapshots from "@/composables/useSnapshots";
import useSchedulePlanSync from "@/composables/useSchedulePlanSync";
import usePreventUnloadWhen from "@/composables/usePreventUnloadWhen";
import useNotifications from "@/composables/useNotifications";

export interface Props {
  cohortId: string;
  timezone: string;
  finalizeRedirectUrl: string;
  criticalError?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TermTweaker',
  props: {
    cohortId: {},
    timezone: {},
    finalizeRedirectUrl: {},
    criticalError: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const showConfirmation = ref(false);
const showError = ref(false);
const finalizing = ref(false);
const initialPlanId = ref<number>();
const notificationsEnabled = ref(false);

const { initializePlan, finalizePlan, syncStatus, canFinalize, currentPlan } =
  useSchedulePlanSync(props.cohortId);
useSnapshots();
const { updateNotification, clearNotification, currentNotification } =
  useNotifications(notificationsEnabled);

const initialized = computed(() => initialPlanId.value !== undefined);
const hasUnsavedChanges = computed(() => {
  return !!initialPlanId.value && initialPlanId.value !== currentPlan.value?.id;
});

const preventUnload = usePreventUnloadWhen(hasUnsavedChanges);

const handleFinalize = async () => {
  try {
    finalizing.value = true;
    await finalizePlan();
    preventUnload.clear();
    showConfirmation.value = false;
    window.location.href = props.finalizeRedirectUrl;
  } catch (err) {
    showConfirmation.value = false;
    showError.value = true;
    finalizing.value = false;
    throw err;
  }
};

const syncMessage = computed(() => {
  switch (syncStatus.value) {
    case "dirty":
      return "Unvalidated changes";
    case "syncing":
      return "Validating schedule.";
    case "valid":
      return "Your schedule is valid.";
    case "invalid":
      return "Your schedule is invalid.";
    default:
      return undefined;
  }
});

watch(syncMessage, (message) => {
  if (message) {
    updateNotification(message);
  }
});

onMounted(async () => {
  Settings.defaultZone = props.timezone;
  await initializePlan();
  initialPlanId.value = currentPlan.value?.id;
  notificationsEnabled.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-wrapper", { 'calendar-errors': _ctx.criticalError }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          class: "btn btn-burg finalize-edits",
          disabled: !_unref(canFinalize),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showConfirmation.value = true))
        }, " Save Edits ", 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (initialized.value || _ctx.criticalError)
        ? (_openBlock(), _createBlock(PlannerCalendar, { key: 0 }))
        : (_openBlock(), _createBlock(LoadingIndicator, { key: 1 }))
    ]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_unref(currentNotification))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["alert alert-calendar", `alert-${_unref(syncStatus)}`]),
              role: "alert"
            }, [
              _createElementVNode("p", null, _toDisplayString(_unref(currentNotification)), 1),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(clearNotification) && _unref(clearNotification)(...args))),
                type: "button",
                class: "btn-close btn-circle-small",
                "aria-label": "Close alert"
              })
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_unref(currentPlan))
      ? (_openBlock(), _createBlock(PlannerFinalizeModal, {
          key: 0,
          modelValue: showConfirmation.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showConfirmation).value = $event)),
          plan: _unref(currentPlan),
          finalizing: finalizing.value,
          onFinalize: handleFinalize,
          onCancel: _cache[3] || (_cache[3] = ($event: any) => (showConfirmation.value = false))
        }, null, 8, ["modelValue", "plan", "finalizing"]))
      : _createCommentVNode("", true),
    _createVNode(TandemModal, {
      modelValue: showError.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showError).value = $event))
    }, {
      title: _withCtx(() => [
        _hoisted_6
      ]),
      directions: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}
}

})